module.exports = __webpack_public_path__ + "img/background28.e8d84d95.jpg";